import React from "react";

const PrivacyPolicy = () => (
  <div style={{ maxWidth: 800, margin: "40px auto", padding: 24 }}>
    <h1>Privacy Policy</h1>
    <p>Last updated: February 28, 2026</p>
    <p>
      <strong>Books of Badsha</strong> is committed to protecting your privacy. This Privacy Policy explains how we collect, use, and safeguard your information when you use our app, which features several PDF works by the writer Badsha.
    </p>
    <h2>Information We Collect</h2>
    <ul>
      <li><strong>No Personal Data Collected:</strong> We do not collect, store, or share any personal information from users of the app.</li>
      <li><strong>PDF Content:</strong> The app provides access to several PDF documents authored by Badsha. These files are for reading only and do not require user accounts or personal data.</li>
    </ul>
    <h2>Third-Party Services</h2>
    <p>
      The app does not use third-party analytics, advertising, or tracking services. If you access external links from within the PDFs, those sites may have their own privacy policies.
    </p>
    <h2>Children's Privacy</h2>
    <p>
      Our app does not knowingly collect information from children under 13. If you believe a child has provided us with personal information, please contact us so we can remove it.
    </p>
    <h2>Changes to This Policy</h2>
    <p>
      We may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated date.
    </p>
    <h2>Contact Us</h2>
    <p>
      If you have any questions about this Privacy Policy, please contact us at the support email provided in the app store listing.
    </p>
  </div>
);

export default PrivacyPolicy;
